export default {
  name: 'columns',
  type: 'layout',
  data: {}
}
